/**
 * Simple hash function that generates a deterministic hash for a given input string.
 * Uses the djb2 algorithm for simplicity and good distribution.
 */
export function hash(input: string): string {
  let hash = 5381;

  for (let i = 0; i < input.length; i++) {
    hash = (hash << 5) + hash + input.charCodeAt(i);
  }

  // Convert to positive hex string
  return (hash >>> 0).toString(16);
}
